import { PureComponent } from "react";
import { type InjectedFormProps, reduxForm } from "redux-form";

import { CalloutIntent, DialogComponent } from "widgets";

import { simpleDropdownFieldValidation } from "../../app-utils/form.js";
import { type Attribute } from "../../graphql.js";
import { getAttributeLabel } from "../../redux/modules/sample-admin.js";
import ReactSelectField, { ReactSelectReduxFormField } from "../core/redux-form/ReactSelectField.js";

interface ISelectAttributeFormOwnProps {
  availableAttributes: Attribute[];
  parentContext?: boolean;
  onAddAttributes: (attributes: Attribute[]) => void;
  onClose: () => void;
  isLoading?: boolean;
}

interface ISelectAttributeFormProps extends ISelectAttributeFormOwnProps, InjectedFormProps<any, any> {}

class SelectAttributeFormImpl extends PureComponent<ISelectAttributeFormProps> {
  public static FORM_NAME = "SelectAttributeForm";
  public static FIELD_ATTRIBUTE = "ATTRIBUTE_LIST";

  constructor(props: ISelectAttributeFormProps) {
    super(props);
  }

  handleSubmitData = (values): Promise<any> => {
    const list = values[SelectAttributeFormImpl.FIELD_ATTRIBUTE];
    if (list.length > 0) {
      this.props.onAddAttributes(list);
    }
    this.props.onClose();
    return Promise.resolve(true);
  };

  render() {
    const availableAttributes = this.props.availableAttributes;
    // sort alphabetically, english, case insensitive
    availableAttributes.sort((attr1, attr2) => {
      const label1 = getAttributeLabel(attr1);
      const label2 = getAttributeLabel(attr2);
      return label1.localeCompare(label2, "en", {
        sensitivity: "base",
        // ignorePunctuation: true,
      });
    });

    const warningMessage =
      this.props.parentContext && availableAttributes.length === 0
        ? "You probably did not create any custom parent attributes for this parent type yet. Therefore there is nothing to select here."
        : undefined;
    return (
      <DialogComponent
        mainButton={{
          label: "Add",
          onPress: this.props.handleSubmit(this.handleSubmitData),
        }}
        closeFn={this.props.onClose}
        errorCallout={
          warningMessage && {
            message: warningMessage,
            intent: CalloutIntent.Warning,
          }
        }
      >
        <div style={{ minWidth: 700 }}>
          <ReactSelectReduxFormField
            name={SelectAttributeFormImpl.FIELD_ATTRIBUTE}
            isMulti
            closeMenuOnSelect={false}
            isClearable={false}
            isSearchable={true}
            getOptionValue={(option: Attribute) => option.id}
            getOptionLabel={(option: Attribute) => option.attributeName}
            label={"Select"}
            tooltip={"Please select one or multiple attribute(s)."}
            placeholder={"Select attributes..."}
            filterOption={(option, filter: string) =>
              getAttributeLabel(option.data).toLowerCase().includes(filter.toLowerCase())
            }
            component={ReactSelectField}
            options={availableAttributes}
            validate={simpleDropdownFieldValidation}
            formatOptionLabel={(attribute: Attribute) => <span>{getAttributeLabel(attribute)}</span>}
            isLoading={this.props.isLoading}
          />
        </div>
      </DialogComponent>
    );
  }
}

const SelectAttributeForm = reduxForm({
  form: SelectAttributeFormImpl.FORM_NAME,
})(SelectAttributeFormImpl) as any;
export { SelectAttributeForm };
